import PrintDocument from "../bvcomponents/popups/printPopup/printDocument";

import store from './../store';
import * as types from "./actionTypes";
import {convertImgToBase64URL, THUMBNAIL_SIZES} from "../misc/utils";
import {getFabricatorLogo} from "../misc/fabricatorHardcode";
import {featureThumbnailUrl} from "../misc/helpers";
import {WIZARD_GROUP_TYPES} from "../interfaces/wizardItemInterface";
import {baseNewImagesPath} from "../bvcomponents/assets";
import {ASYNC_SCRIPTS} from "../loadingLogic";
import {loadScriptPromise} from "../misc/loadScript";
import {registerFonts} from "../bvcomponents/popups/printPopup/printDocumentStyles";
import {IS_AS_WORK_ORDER} from "../config";

let printLogo = "";
let notFoundImage = "";

export const loadReceiptScript = async () => {
  await loadScriptPromise(ASYNC_SCRIPTS.bundleReactPdfRenderer, "bundleReactPdfRenderer");
  registerFonts();
}

export const getCurrentReceipt = async (assignQuotePopupNewCustomer, newEmployeeSelected, onRender, isContractSign) => {

  const {userState, serverState, fabricatorState, cartState, quotesState, priceWorksheetState,
    filterState, assignQuoteState, wizardState, sqftSlabState, printState, paymentState} = store.getState();

  const {assignQuotePopupCustomer, assignQuotePopupEmployee} = assignQuoteState;

  await loadReceiptScript();

  printLogo = IS_AS_WORK_ORDER
    ? null
    : printLogo || await convertImgToBase64URL(getFabricatorLogo(fabricatorState));
  let cartItemsThumbnails = {};
  if (fabricatorState.receiptSettings && fabricatorState.receiptSettings.showThumbnailsAndDescriptions) {
    cartItemsThumbnails = await getCartItemThumbnails(cartState.cartItems, wizardState);
  }

  return window.ReactPdfRenderer.pdf(PrintDocument({
    fabricatorData: fabricatorState,
    userInfo: userState.userInfo,
    quotes: quotesState.quotes,
    cartItems: cartState.cartItems,
    priceWorksheetState,
    assignQuotePopupCustomer: assignQuotePopupNewCustomer || assignQuotePopupCustomer,
    employeeSelected: newEmployeeSelected || assignQuotePopupEmployee,
    locale: serverState.language,
    filterGroups: filterState.filterGroups,
    activeTheme: serverState.activeTheme,
    jobId: serverState.jobId,
    printLogo,
    wizardState,
    sqftSlabState,
    cartItemsThumbnails,
    printState,
    paymentState,
    onRender,
    isContractSign,
  }))
}

// export const getCurrentReceiptPages = async (withReceiptUrl) => {
//   try {
//     const pdfReceipt = await getCurrentReceipt();
//     if (pdfReceipt && pdfReceipt.container && pdfReceipt.container.render) {
//       await pdfReceipt.container.render();
//       if (pdfReceipt.container.document && pdfReceipt.container.document.getLayoutData) {
//         const layoutData = pdfReceipt.container.document.getLayoutData();
//         if (layoutData && Array.isArray(layoutData.children) && layoutData.children.length) {
//           if (withReceiptUrl) {
//             const receipt = await pdfReceipt.toBlob();
//             const receiptUrl = URL.createObjectURL(receipt);
//             return {receiptUrl, receiptPages: layoutData.children.length};
//           }
//           return layoutData.children.length
//         }
//       }
//     }
//     if (withReceiptUrl) {
//       return {receiptUrl: "", receiptPages: 0};
//     }
//     return 0
//   } catch (e) {
//     console.log("error rendering pdf receipt", e);
//     if (withReceiptUrl) {
//       return {receiptUrl: "", receiptPages: 0};
//     }
//     return 0
//   }
// }

export const getCurrentReceiptPages = async (withReceiptUrl) => {
  try {
    let imagesPromise = new Promise(async (resolve) => {
      const onRender = (onRenObj) => {
        // console.log("onRender!!", onRenObj);
        const receiptLayout = onRenObj ? onRenObj._INTERNAL__LAYOUT__DATA_ : null;
        const receiptPages = receiptLayout && receiptLayout.children ? receiptLayout.children.length : 1;
        const receiptUrl = URL.createObjectURL(onRenObj.blob);

        resolve({receiptUrl, receiptLayout, receiptPages})
      };
      const pdfReceipt2 = await getCurrentReceipt(null, null, onRender, true)
      await pdfReceipt2.toBlob();
    })
    if (withReceiptUrl) {
      return imagesPromise.then(response => response)
    }
    return 0
  } catch (e) {
    console.log("error rendering pdf receipt", e);
    if (withReceiptUrl) {
      return {receiptUrl: "", receiptPages: 0};
    }
    return 0
  }
}

export const getCartItemThumbnails = async (cartItems, wizardState) => {
  let cartItemsThumbnails = {};
  for (const cartItem of cartItems) {
    try {
      const thumbnailUrl = featureThumbnailUrl(cartItem.cartFeature, THUMBNAIL_SIZES.small);
      cartItemsThumbnails[cartItem.id] = await convertImgToBase64URL(thumbnailUrl);
      if (!cartItemsThumbnails[cartItem.id]) {
        if (!notFoundImage) {
          notFoundImage = await convertImgToBase64URL(`${baseNewImagesPath}images/image-not-found.png`);
        }
        cartItemsThumbnails[cartItem.id] = notFoundImage
      }
    } catch (e) {
      cartItemsThumbnails[cartItem.id] = `${baseNewImagesPath}images/image-not-found.png`;
    }
  }
  for (const wizard of wizardState.allWizardsValues) {
    for (const key of Object.keys(wizard.wizardSelectedValues)) {
      if (wizard.wizardSelectedValues[key].wizardGroup
        && (wizard.wizardSelectedValues[key].wizardGroup.nodeType === WIZARD_GROUP_TYPES.custom)
        && wizard.wizardSelectedValues[key].wizardGroup.customImageUrl) {
        try {
          cartItemsThumbnails[wizard.wizardSelectedValues[key].wizardGroup.id] = await convertImgToBase64URL(
            `https://corsproxy.io/?url=${encodeURIComponent(wizard.wizardSelectedValues[key].wizardGroup.customImageUrl)}`
          );
          if (!cartItemsThumbnails[wizard.wizardSelectedValues[key].wizardGroup.id]) {
            cartItemsThumbnails[wizard.wizardSelectedValues[key].wizardGroup.id] = await convertImgToBase64URL(
              `https://proxy.corsfix.com/?${wizard.wizardSelectedValues[key].wizardGroup.customImageUrl}`
            );
          }
          if (!cartItemsThumbnails[wizard.wizardSelectedValues[key].wizardGroup.id]) {
            cartItemsThumbnails[wizard.wizardSelectedValues[key].wizardGroup.id] = await convertImgToBase64URL(
              wizard.wizardSelectedValues[key].wizardGroup.customImageUrl
            );
          }
          if (!cartItemsThumbnails[wizard.wizardSelectedValues[key].wizardGroup.id]) {
            cartItemsThumbnails[wizard.wizardSelectedValues[key].wizardGroup.id] = await convertImgToBase64URL(
              wizard.wizardSelectedValues[key].wizardGroup.customImageUrl + "?not-from-cache-please"
            );
          }
          if (!cartItemsThumbnails[wizard.wizardSelectedValues[key].wizardGroup.id]) {
            if (!notFoundImage) {
              notFoundImage = await convertImgToBase64URL(`${baseNewImagesPath}images/image-not-found.png`);
            }
            cartItemsThumbnails[wizard.wizardSelectedValues[key].wizardGroup.id] = notFoundImage
          }
        } catch (e) {
          cartItemsThumbnails[wizard.wizardSelectedValues[key].wizardGroup.id] = `${baseNewImagesPath}images/image-not-found.png`;
        }
      }
    }
  }
  return cartItemsThumbnails
}

export const getOfflineReceiptImages = async () => {
  const {fabricatorState} = store.getState();
  notFoundImage = await convertImgToBase64URL(`${baseNewImagesPath}images/image-not-found.png`)
  printLogo = await convertImgToBase64URL(getFabricatorLogo(fabricatorState));
  await getCurrentReceiptPages(true);
  return true
}

export const printReceipt = async () => {
  const pdfReceipt = await getCurrentReceipt();
  const receipt = await pdfReceipt.toBlob();
  const fileURL = URL.createObjectURL(receipt);
  window.open(fileURL, "_blank");
}

export const setReceiptUrl = (receiptUrl) => ({
  type: types.SET_RECEIPT_URL,
  payload: {receiptUrl}
})

export const setReceiptSignature = (receiptSignature) => ({
  type: types.SET_RECEIPT_SIGNATURE,
  payload: {receiptSignature}
})

export const setReceiptReferral = (receiptReferral) => ({
  type: types.SET_RECEIPT_REFERRAL,
  payload: {receiptReferral}
})
